<template>
  <b-row v-if="cancelled_context_loaded" class="m-0">
    <b-col xl="6" lg="12" class="pr-2 pb-4 pl-2">
      <b-container fluid class="white-box">
        <highcharts :options="barChartOptions_1"></highcharts>
      </b-container>
    </b-col>
    <b-col xl="6" lg="12" class="pr-2 pb-4 pl-2">
      <b-container fluid class="white-box">
        <highcharts :options="barChartOptions_2"></highcharts>
        <no-data v-if="dissatisfaction_data.length < 1"></no-data>
      </b-container>
    </b-col>
  </b-row>
  <loader-box v-else height="408px" class="mb-4 mr-2 ml-2"/>
</template>

<script>
import Highcharts from 'highcharts'
import LoaderBox from '@/components/LoaderBox.vue'
import NoData from '@/components/NoData.vue'

export default {
  components: {
    LoaderBox,
    NoData
  },
  computed: {
    cancelled_context_loaded() { return this.$store.getters.cancelled_context_loaded },
    total_cancelled_count() { return this.$store.getters.total_cancelled_count },
    pie_data_cancelled_values() { return this.$store.getters.pie_data_cancelled_values },
    dissatisfaction_count() { return this.$store.getters.dissatisfaction_count },
    dissatisfaction_data() { return this.$store.getters.dissatisfaction_data },
    barChartOptions_1() {
      const COUNT = this.total_cancelled_count;
      const DATA = this.pie_data_cancelled_values;
      return {
        chart: {
          type: 'bar',
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false
        },
        title: {
          text: 'Tipos de cancelamento'
        },
        subtitle: {
          text: COUNT + ' pedidos',
        },
        xAxis: {
          visible: false
        },
        yAxis: {
          title: {
            text: 'quantidade'
          }
        },
        tooltip: {
          headerFormat: '',
          pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>'
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
              formatter: function() {
                return Highcharts.numberFormat(this.point.y * 100 / COUNT, 2) + '%'
              },
            },
            size: '110%'
          }
        },
        series: DATA
      }
    },
    barChartOptions_2() {
      const COUNT = this.dissatisfaction_count;
      const DATA = this.dissatisfaction_data;
      return {
        chart: {
          type: 'bar',
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false
        },
        title: {
          text: 'Motivos de devolução'
        },
        subtitle: {
          text: COUNT + ' pedidos',
        },
        xAxis: {
          visible: false
        },
        yAxis: {
          title: {
            text: 'quantidade'
          },
        },
        tooltip: {
          headerFormat: '',
          pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>'
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
              formatter: function() {
                return Highcharts.numberFormat(this.point.y * 100 / COUNT, 2) + '%'
              }
            },
            size: '110%'
          }
        },
        series: DATA
      }
    }
  }
}
</script>

<style>

</style>
